import toggle from '../../global/toggle';

function scrollToTable() {
    const table = document.querySelector('.js_oraComparisonTable');

    if (table && !table.classList.contains('oraComparisonTable--expanded')) {
        table.scrollIntoView({
            behavior: 'smooth',
        });
    }
}

function init() {
    toggle({
        buttonClasses: {
            hookClass: 'js_oraComparisonTable__toggleButton',
            toggleClass: 'oraComparisonTable__toggleButton--showLess'
        },
        targetClassesList: [
            {
                hookClass: 'js_oraComparisonTable',
                toggleClass: 'oraComparisonTable--expanded'
            }
        ],
        callback: scrollToTable,
    });
}

$(document).ready(init);
